// Your professional and academic journey
export const journeyData = [
  {
    id: 'iiit-hyderabad',
    year: '2017-2021',
    startYear: 2017,
    endYear: 2021,
    title: 'IIIT Hyderabad',
    role: 'BTech (Honours) in Computer Science',
    type: 'education',
    location: 'Hyderabad, India',
    coordinates: [78.5482, 17.4449], // [longitude, latitude]
    icon: '🎓',
    color: '#00D9FF',
    logo: 'https://logo.clearbit.com/iiit.ac.in',
    website: 'https://www.iiit.ac.in/',
    description: 'Started my journey in Computer Science with a focus on Machine Learning and Systems. Graduated with honours and a stellar 9.48 CGPA.',
    achievements: [
      'CGPA: 9.48/10 (Honours)',
      'Machine Learning Lab Researcher',
      'Published paper at PRICAI\'21',
      'Strong foundation in CS fundamentals',
    ],
    techStack: ['Python', 'C++', 'Machine Learning', 'Algorithms', 'Data Structures'],
    metrics: {
      duration: '4 years',
      achievement: '9.48 CGPA',
    },
  },
  {
    id: 'ml-lab',
    year: '2019-2021',
    startYear: 2019,
    endYear: 2021,
    title: 'Machine Learning Lab',
    role: 'Undergraduate Researcher',
    type: 'research',
    location: 'Hyderabad, India',
    coordinates: [78.5482, 17.4449], // Same as IIIT
    icon: '🔬',
    color: '#7C3AED',
    logo: 'https://logo.clearbit.com/iiit.ac.in',
    website: 'https://mll.iiit.ac.in/',
    description: 'Research on Multi-Arm Bandit algorithms and classification under partial feedback settings, advised by Prof. Naresh Manwani.',
    achievements: [
      'Published at PRICAI\'21 Conference',
      'Multiclass Classification under Dilute Bandit Feedback',
      'Developed novel ML algorithms',
      'Research experience in theoretical ML',
    ],
    techStack: ['Python', 'Machine Learning', 'Bandit Algorithms', 'Research', 'PyTorch'],
    metrics: {
      duration: '2 years',
      achievement: '1 Publication',
    },
  },
  {
    id: 'nvidia',
    year: '2020',
    startYear: 2020,
    endYear: 2020,
    title: 'NVIDIA',
    role: 'Software Engineer Intern - AI',
    type: 'work',
    location: 'Pune, India',
    coordinates: [73.8567, 18.5204],
    icon: '💼',
    color: '#76B900', // NVIDIA green
    logo: 'https://logo.clearbit.com/nvidia.com',
    website: 'https://www.nvidia.com/',
    description: 'Worked on deep learning-based image compression for GeForce Now cloud gaming platform. Optimized video encoding for bandwidth-constrained environments.',
    achievements: [
      '15% improvement in PSNR scores',
      '10% increase in SSIM metrics',
      '27% overall performance improvement',
      'TensorFlow CNN for image pre-processing',
    ],
    techStack: ['TensorFlow', 'PyTorch', 'Computer Vision', 'Image Compression', 'C++'],
    metrics: {
      duration: '3 months',
      achievement: '27% improvement',
    },
  },
  {
    id: 'couture-ai',
    year: '2021-2024',
    startYear: 2021,
    endYear: 2024,
    title: 'Couture.ai',
    role: 'AI Platform Engineer',
    type: 'work',
    location: 'Bengaluru, India',
    coordinates: [77.5946, 12.9716],
    icon: '🚀',
    color: '#00D9FF',
    logo: 'https://logo.clearbit.com/caistack.com',
    website: 'https://caistack.com/',
    description: 'Core platform engineer building and scaling the Couture.ai MLOps platform. Led infrastructure design, optimization, and the first U.S. client deployment.',
    achievements: [
      '40% reduction in deployment time (Rust optimization)',
      '20% improvement in inference throughput',
      '$250k ARR from first U.S. client',
      '15+ microservices built and deployed',
      '90% reduction in manual deployment',
      '75% faster issue discovery with Grafana Loki',
    ],
    techStack: ['Python', 'Golang', 'Rust', 'Kubernetes', 'AWS', 'GCP', 'FastAPI', 'PostgreSQL', 'Redis'],
    metrics: {
      duration: '3 years',
      achievement: '$250k ARR',
    },
    highlight: true, // Special styling for this major experience
  },
  {
    id: 'uw-madison',
    year: '2024-2026',
    startYear: 2024,
    endYear: 2026,
    title: 'UW-Madison',
    role: 'Master of Science in Computer Science',
    type: 'education',
    location: 'Madison, WI, USA',
    coordinates: [-89.4012, 43.0731],
    icon: '🎓',
    color: '#C5050C', // UW-Madison red
    logo: 'https://logo.clearbit.com/wisc.edu',
    website: 'https://www.cs.wisc.edu/',
    description: 'Pursuing MS in Computer Science with specialization in Systems and AI/ML. Building expertise in distributed systems, filesystems, and large-scale ML infrastructure.',
    achievements: [
      'GPA: 3.92/4.0',
      'Custom Filesystem with FUSE (C)',
      'Multi-GPU LLM Fine-Tuning Pipeline',
      'Deduplication for 10M+ documents',
    ],
    techStack: ['C', 'FUSE', 'Distributed Systems', 'PyTorch', 'Hugging Face', 'Multi-GPU Training'],
    metrics: {
      duration: '2 years',
      achievement: '3.92 GPA',
    },
    current: true, // Currently here
  },
  {
    id: 'sigma-computing',
    year: 'May - Aug 2024',
    startYear: 2024,
    endYear: 2024,
    title: 'Sigma Computing',
    role: 'Software Engineering Intern - AI',
    type: 'work',
    location: 'San Francisco, CA, USA',
    coordinates: [-122.4194, 37.7749],
    icon: '✨',
    color: '#7C3AED',
    logo: 'https://logo.clearbit.com/sigmacomputing.com',
    website: 'https://www.sigmacomputing.com/',
    description: 'Built semantic search features for Ask Sigma. Deployed scalable ML services on Kubernetes for natural language workbook discovery.',
    achievements: [
      '30% improvement over legacy search',
      '100+ daily queries served',
      '10% lower latency',
      'Production ML deployment',
    ],
    techStack: ['Python', 'Kubernetes', 'Semantic Search', 'NLP', 'Production ML'],
    metrics: {
      duration: '3 months',
      achievement: '30% improvement',
    },
  },
];

// Summary stats for hero section
export const journeyStats = {
  cities: 5,
  countries: 2,
  continents: 2,
  yearsExperience: 3.5,
  degrees: 2,
  publications: 1,
  microservices: 15,
  arrContribution: 250000,
  performanceImprovement: 40,
};

export default journeyData;